// NUDAE Theme JS

// Mobile menu toggle
function toggleMobileMenu() {
  const menu = document.getElementById('mobileMenu');
  const overlay = document.getElementById('mobileOverlay');
  if (menu && overlay) {
    menu.classList.toggle('open');
    overlay.classList.toggle('open');
    document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
  }
}

// Sticky nav shadow on scroll
window.addEventListener('scroll', function() {
  const nav = document.querySelector('.site-nav');
  if (nav) {
    nav.style.boxShadow = window.scrollY > 10
      ? '0 2px 20px rgba(30,23,20,0.08)'
      : 'none';
  }
});

// Simple add-to-cart feedback
document.addEventListener('submit', function(e) {
  const btn = e.target.querySelector('.atc-btn, .btn-dark[type="submit"]');
  if (btn && e.target.action && e.target.action.includes('/cart/add')) {
    const original = btn.textContent;
    btn.textContent = 'Added!';
    btn.style.background = 'var(--plum)';
    btn.style.color = 'var(--plum-pale)';
    btn.style.borderColor = 'var(--plum)';
    setTimeout(function() {
      btn.textContent = original;
      btn.style.background = '';
      btn.style.color = '';
      btn.style.borderColor = '';
    }, 2000);
  }
});

// Animate elements on scroll
const observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, { threshold: 0.1 });

document.addEventListener('DOMContentLoaded', function() {
  const animItems = document.querySelectorAll(
    '.product-card, .testimonial, .benefit-item, .ing-cell, .why-stat'
  );
  animItems.forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.5s ease ' + (i * 0.08) + 's, transform 0.5s ease ' + (i * 0.08) + 's';
    observer.observe(el);
  });
});
